import { z } from 'zod';

export const DashboardLiveGetResponse = z.object({
  count: z.object({
    in_queue: z.number(),
    in_queue_total: z.number(),
  }),
});

export type DashboardLiveGetResponseType = z.infer<typeof DashboardLiveGetResponse>;
